import {Module} from 'vuex-class-modules';
import store from '@/store';
import {dropdownChainApi as api} from '@/api';
import {
  DropdownChainAttributes as Attributes,
  DropdownChainCreate as Create,
  DropdownChainResource as Resource,
} from '@/interfaces';
import {ResourceType} from '@/enums';
import {CrudModuleAbstract} from './CrudModuleAbstract';
import {parseISO} from 'date-fns';

const defaultItem = (): Resource => {
  return {
    id: 'new',
    type: ResourceType.DropdownChain,
    attributes: {
      id: 0,
      name: '',
      label: '',
      parentId: 0,
      value: '',
      userCreated: {id: 0, firstName: '', lastName: ''},
      userModified: {id: 0, firstName: '', lastName: ''},
      userIdCreated: 0,
      userIdModified: 0,
      created: new Date(),
      modified: new Date(),
    },
  };
};

@Module
class DropdownChainModule extends CrudModuleAbstract<
  Resource,
  Attributes,
  Create
> {
  public cast(item: Resource): Resource {
    item.attributes.created = parseISO(String(item.attributes.created));
    item.attributes.modified = parseISO(String(item.attributes.modified));
    return item;
  }
}

export const dropdownChainModule = new DropdownChainModule(
  {
    store,
    name: ResourceType.DropdownChain,
  },
  () => api,
  defaultItem
);
